var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "63px",
    viewBox: "0 0 51 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "730E8574-367A-4FA5-9B14-2D0D2C10C74D") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8.-what-can-help",
    transform: "translate(-368.000000, -481.000000)",
    strokeWidth: 2.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(370.000000, 483.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.42637,29.60082 C5.42637,30.09777 5.82912,30.50037 6.32607,30.50037 C6.82287,30.50037 7.22562,30.09777 7.22562,29.60082 C7.22562,29.10387 6.82287,28.70127 6.32607,28.70127 C5.82912,28.70127 5.42637,29.10387 5.42637,29.60082 Z",
    id: "Stroke-1",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    stroke: "#222456",
    points: "33.63105 16.155465 33.63105 1.5e-05 0 1.5e-05 0 59.201715 33.63105 59.201715 33.63105 43.046115"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.336715,27.337485 L29.337315,25.663185 C29.325315,23.472735 31.108065,21.667185 33.298515,21.6557306 L33.912915,21.6557306 C36.103215,21.644385 37.904715,23.426685 37.916565,25.616985 L37.916565,27.337485",
    id: "Stroke-5",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.660285,34.520205 C27.660285,36.184155 29.093535,37.545855 30.846285,37.545855 L36.415935,37.545855 C38.168085,37.545855 39.601785,36.184155 39.601785,34.520205 L39.601785,29.022105 C39.601785,28.729755 39.362835,28.490805 39.070935,28.490805 L28.191285,28.490805 C27.898785,28.490805 27.660285,28.729755 27.660285,29.022105 L27.660285,34.520205 Z",
    id: "Stroke-7",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.63084,
    y1: 32.09589,
    x2: 33.63084,
    y2: 34.36359,
    id: "Stroke-9",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.064355,31.945005 C34.064355,32.185455 33.871455,32.378655 33.631305,32.378655 C33.392355,32.378655 33.197355,32.185455 33.197355,31.945005 C33.197355,31.704705 33.392355,31.511505 33.631305,31.511505 C33.871455,31.511505 34.064355,31.704705 34.064355,31.945005 Z",
    id: "Stroke-11",
    stroke: "#ED7330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.07642,29.60082 C47.07642,37.02642 41.05677,43.04622 33.63102,43.04622 C26.20542,43.04622 20.18577,37.02642 20.18577,29.60082 C20.18577,22.17522 26.20542,16.15542 33.63102,16.15542 C41.05677,16.15542 47.07642,22.17522 47.07642,29.60082 Z",
    id: "Stroke-13",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.664505,
    y1: 6.963705,
    x2: 34.664505,
    y2: 9.191805,
    id: "Stroke-15",
    stroke: "#222456"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.664505,
    y1: 50.009895,
    x2: 34.664505,
    y2: 52.237995,
    id: "Stroke-17",
    stroke: "#222456"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorLock);
export default __webpack_public_path__ + "static/media/doorLock.16115208.svg";
export { ForwardRef as ReactComponent };